module.exports = __webpack_public_path__ + "img/packshots-hd(old).977bd9bd.png";